import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource-variable/manrope';
import { App } from '@/app/App';
import '@/app/styles.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Application root element was not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
